import { Image } from 'component/Image'
import { Link } from 'component/Link'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './SecondButton.module.scss'

export const SecondButton = observer(() => {
  const { welcome } = useDemo()
  const { secondImage, secondUrl } = welcome!

  if (!secondImage || !secondUrl) return null

  return <Link className={css.button} href={secondUrl} here>
    <Image className={css.image} src={secondImage} />
  </Link>
})
